import React from "react";
import { useRouter } from 'next/router'

import {Backdrop, Button, CircularProgress, makeStyles} from "@material-ui/core";


const useStyles = makeStyles(theme => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
},  
}));


const Loader = ({isBackdrop}) => {
const classes = useStyles();
  const router = useRouter();

  return (
    <Backdrop className={classes.backdrop} open={isBackdrop}>
        <CircularProgress color="inherit"/>
    </Backdrop>
  );
};

export default Loader;